import { Money } from '@app/features/scope-overview/model/money.model'
import { DEFAULT_PLACEHOLDER } from '@app/shared/constants/default-placeholder.const'
import { ConvertCurrencyPipe } from '@app/shared/pipe/convertCurrency.pipe'
import { isNil, isNumber, round } from 'lodash'

export const formatPercentage = (value: number | string): string => {
  if (isNil(value) || value === DEFAULT_PLACEHOLDER || (isNumber(value) && isNaN(value))) return DEFAULT_PLACEHOLDER

  const formattedValue = (+value % 10 ? round(+value || 0, 2) : value) || 0
  return `${formattedValue}%`
}

export const formatCrPrice = (
  value: number | Money,
  currency: string,
  convertCurrencyPipe: ConvertCurrencyPipe
): string => {
  const amount = value instanceof Money ? value.amount : value
  return isNil(amount) || (isNumber(amount) && isNaN(amount))
    ? DEFAULT_PLACEHOLDER
    : convertCurrencyPipe.transform(amount, currency)
}

export const formatCrModifier = (value: number): string | number =>
  !isNil(value) && value !== 1 && !isNaN(value) ? value : DEFAULT_PLACEHOLDER
